// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"148":"050c2c30","443":"5fd1ad4c"}[chunkId] + ".css";
};